import basketFunctions from './basketFunctions'

export default function ColourChip() {
    colourPopup();
}

const chipIcon = document.querySelectorAll('.colour-chip-icon'),
    chipPopup = document.querySelector('.colour-pop-up'),
    closePopup = document.getElementById('closePopup'),
    addChipstoBasket = document.getElementById('addAllChips');

const arrowsContainer = document.querySelector(".look-book-popup__arrows-wrapper");
const lookBookIndexArr = [];

function colourPopup() {
    chipIcon.forEach(el => el.addEventListener('click', e => {
        e.preventDefault();

        colourPopupInit(el);

    }));

    let lookBookItems = document.querySelectorAll('.look-book-item');

    if (lookBookItems.length > 0) {
        lookBookItems.forEach(el => {
            let indexNum = parseInt(el.getAttribute('data-lookbook-index'));
            lookBookIndexArr.push(indexNum);

            el.addEventListener('click', e => {
                e.preventDefault();
                colourPopupInit(el);

            })
        });

        loadNextPopup();
    }


    if (closePopup) {
        colourClose();
    }
}

function colourPopupInit(el) {
    var imageUrl = el.getAttribute("data-image");
    var chipImage = document.querySelector('.colour-pop-up img');
    chipImage.setAttribute('src', imageUrl);

    var colourChips = JSON.parse(el.getAttribute("data-chips"));

    for (let i = 0; i < colourChips.length; i++) {

        let obj = colourChips[i];

        if (obj.BulkBasketUrl != null) {
            if (addChipstoBasket) {
                addChipstoBasket.setAttribute('href', obj.BulkBasketUrl)
                addChipstoBasket.removeAttribute('style');
            }
        } else {

            var hrefCheck = obj.Url != "null" && obj.Url != "";

            var html = ` <div class="colour-chip chip-wrap" data-url="${hrefCheck ? obj.Url : ""}">
                                    <div class="colour-chip-inner colour-chip-inner-popup colour-chip-colour" style="background: rgb(${obj.ColourRgb}); color: rgba(${obj.ColourRgb},.6)">
                                        ${obj.ChipInStock && obj.ChipRef != 0 && !obj.HideEcommerce ? '<div class="slide-basket"><a href="' + obj.AddToBasket + '" class="add-to-basket" ><svg class="icon" ><use href="#sprite-plus"></use></svg ></a ></div>' : ''}
                                    </div>
                                    <div class="colour-chip-info">
                                        <p class="colour p-popup">${obj.DisplayName}</p>
                                        <p>${obj.ColourRef}</p>
                                    </div>
                                </div>`;

            document.querySelector('.colour-pop-up .chips').insertAdjacentHTML("beforeend", html);
        }
    }

    if (colourChips.length < 2) {
        document.getElementById('addAllChips').style.display = "none";
    }

    colourHref();

    if (el.classList.contains("look-book-item")) {

        if (addChipstoBasket) {
            addChipstoBasket.classList.add('hidden');
        }

        chipPopup.querySelector('.socials').classList.remove('hidden');

        let handle = el.getAttribute('data-instahandle');

        if (handle.length != 0) {
            chipPopup.querySelector('.socials').classList.remove("right-align");
            chipPopup.querySelector('.handle span').innerHTML = "@" + handle;
            chipPopup.querySelector('.handle').classList.remove('hidden');
        }
        else {
            chipPopup.querySelector('.handle').classList.add('hidden');
            chipPopup.querySelector('.socials').classList.add("right-align");
        }

        var shareUrl = el.getAttribute('data-lookbook-shareurl')

        if (shareUrl != "") {
            chipPopup.querySelector('.facebook-social').href = "http://www.facebook.com/sharer.php?u=" + shareUrl;
            chipPopup.querySelector('.twitter-social').href = "https://twitter.com/share?url=" + shareUrl;
            chipPopup.querySelector('.pinterest-social').href = "http://pinterest.com/pin/create/button/?url=" + shareUrl;
        }

        let indexNum = parseInt(el.getAttribute('data-lookbook-index'));
        let currentIndex = lookBookIndexArr.indexOf(indexNum);

        let prevIndex = lookBookIndexArr.at(-1);
        let nextIndex = lookBookIndexArr[currentIndex + 1];

        if (currentIndex != 0) {
            prevIndex = lookBookIndexArr[currentIndex - 1];
        }

        if (currentIndex == lookBookIndexArr.length - 1) {
            nextIndex = lookBookIndexArr[0];
        }

        if (arrowsContainer) {
            arrowsContainer.querySelector('.prev').setAttribute('data-id', prevIndex)
            arrowsContainer.querySelector('.next').setAttribute('data-id', nextIndex)
        }


    }
    else {
        arrowsContainer.parentElement.classList.add('hidden');
    }

    chipPopup.classList.add('open');

    colourClose();
    basketFunctions();
    preLoader();
}

function loadNextPopup() {
    if (arrowsContainer) {

        arrowsContainer.parentElement.classList.remove('hidden');

        arrowsContainer.querySelector('.next').addEventListener('click', function (e) {

            let nextIndex = arrowsContainer.querySelector('.next').getAttribute("data-id");

            let nextItem = document.querySelector('[data-lookbook-index="' + nextIndex + '"]');

            document.querySelectorAll(".chip-wrap").forEach(el => el.remove());

            nextItem.click();
        });

        arrowsContainer.querySelector('.prev').addEventListener('click', function (e) {

            let prevIndex = arrowsContainer.querySelector('.prev').getAttribute("data-id");
            let prevItem = document.querySelector('.look-book-item[data-lookbook-index="' + prevIndex + '"]');

            document.querySelectorAll(".chip-wrap").forEach(el => el.remove());

            prevItem.click();
        });
    }
}

function colourClose() {
    document.getElementById('closePopup').addEventListener("click", function (e) {
        chipPopup.classList.remove('open');
        chipPopup.querySelector('.socials').classList.add('hidden');
        if (addChipstoBasket) {
            addChipstoBasket.classList.remove('hidden');
        }
        document.querySelectorAll(".chip-wrap").forEach(el => el.remove());
    }, false);
}

function preLoader() {

    if (addChipstoBasket) {
        addChipstoBasket.addEventListener("click", function (e) {
            this.classList.add('transparent');
            document.querySelector('.loader').style.display = "block";
        }, false);
    }
}

function colourHref() {
    let colourChips = chipPopup.querySelectorAll(".colour-chip");

    colourChips.forEach(element => {
        element.addEventListener("click", function (e) {
            let url = element.getAttribute("data-url");

            if (url != "" && url != "null") {
                window.location.href = url;
            }

        });
    });
}
